import { show } from 'redux-modal'
import { FORGOT_USERNAME_MODAL, FORGOT_PASSWORD_MODAL } from 'constant'

export const showRecoveryModal = path => (dispatch) => {
  const typeFromPath = path.match(/password|email/)
  const actions = {
    password: FORGOT_PASSWORD_MODAL,
    email: FORGOT_USERNAME_MODAL
  }
  typeFromPath && dispatch(show(actions[typeFromPath[0]], { path }))
}
